<ng-container *transloco="let t">
  @if (
    {
      countryErrorMessage: countryErrorMessage$ | async,
      nameErrorMessage: nameErrorMessage$ | async,
      phoneErrorMessage: phoneErrorMessage$ | async,
      commentErrorMessage: commentErrorMessage$ | async,
    };
    as data
  ) {
    <fieldset [formGroup]="form">
      <!-- Utländsk organisation -->
      <div class="form-group form-check mt-3 p-0">
        <lib-vinnova-checkboxes
          [checkboxObjects]="[
            { id: 'a', label: t('worksite_foreign_worksite') },
          ]"
          formControlName="isForeign"
          [horizontal]="true"
          singleCheckbox="true"
          [minNumberOfCheckedOptions]="1"
        >
        </lib-vinnova-checkboxes>
      </div>
      <!-- Land -->
      @if (isForeign.value) {
        <div class="form-group">
          <lib-input-container
            formGroupName="address"
            [label]="t('worksite_country')"
            for="worksite-country"
            [required]="true"
            [autoWidth]="false"
            [errorText]="data.countryErrorMessage"
          >
            <lib-vinnova-dropdown
              [id]="'worksite-country'"
              [placeholder]="t('worksite_search_country_placeholder')"
              [items]="countries"
              formControlName="country"
              [error]="!!data.countryErrorMessage"
              [required]="true"
            >
            </lib-vinnova-dropdown>
          </lib-input-container>
        </div>
      }
      <!-- Namn -->
      <div class="form-group">
        <lib-input-container
          for="worksite-name"
          [label]="t('worksite_name')"
          [required]="true"
          [errorText]="data.nameErrorMessage"
        >
          <input
            vinnova-text-input
            id="worksite-name"
            formControlName="name"
            autocomplete="off"
            spellcheck="false"
            [error]="!!data.nameErrorMessage"
          />
        </lib-input-container>
      </div>
      <!-- CFAR/Annat-nummer -->
      <div class="form-group">
        @if (isWorksiteDuplicated) {
          <div class="invalid-feedback">
            <lib-icon name="alert-circle" size="x-small"></lib-icon>
            {{ t('worksite_cfar_exist') }}
          </div>
        }
        <lib-input-container
          [description]="isForeign.value ? '' : t('worksite_cfar_info')"
          for="worksite-number"
          [label]="
            isForeign.value
              ? t('worksite_other_unique_number')
              : t('worksite_cfar')
          "
        >
          <input
            vinnova-text-input
            id="worksite-number"
            formControlName="number"
            autocomplete="off"
            spellcheck="false"
          />
        </lib-input-container>
      </div>
      @if ({ duplicateWorksites: duplicateWorksites$ | async }; as data) {
        @if (
          data.duplicateWorksites &&
          data.duplicateWorksites.length > 0 &&
          !selectedCompany
        ) {
          <div class="row">
            <div class="col-12">
              <div class="alert alert-warning m-0">
                <div class="d-flex align-items-center">
                  <lib-icon name="alert-triangle" size="x-small"></lib-icon>
                  <div class="ms-2">
                    <p class="m-0">{{ t('worksite_worksite_exist') }}</p>
                    <p class="m-0">
                      {{ t('worksite_worksite_exist_info') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="card mt-2">
                <div class="d-flex justify-content-between mt-1">
                  <div>
                    <p class="m-0">{{ data.duplicateWorksites[0].name }}</p>
                    <p class="m-0">
                      <small> {{ number.value }}</small>
                    </p>
                  </div>
                  <button
                    vinnova-button-text
                    type="button"
                    (click)="onSelectWorksite(data.duplicateWorksites[0])"
                  >
                    {{ t('worksite_select') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      }
      <!-- Adress -->
      <lib-create-address
        [form]="addressForm"
        [name]="'worksite'"
        [isForeign]="isForeign.value"
      ></lib-create-address>
      <!-- Telefonnummer -->
      <div class="form-group">
        <lib-input-container
          for="worksite-phone"
          [label]="t('worksite_phone')"
          [errorText]="data.phoneErrorMessage"
        >
          <lib-text-input-phone
            [id]="'worksite-phone'"
            formControlName="phone"
            [error]="!!data.phoneErrorMessage"
          >
          </lib-text-input-phone>
        </lib-input-container>
      </div>
      <!-- Kommentar -->
      <div class="form-group">
        <lib-input-container
          for="worksite-comment"
          [required]="true"
          [label]="t('worksite_worksite_create_reason')"
          [errorText]="data.commentErrorMessage"
        >
          <textarea
            vinnova-textarea
            [required]="true"
            id="worksite-comment"
            formControlName="comment"
            [error]="!!data.commentErrorMessage"
          ></textarea>
        </lib-input-container>
      </div>
    </fieldset>
  }
</ng-container>
